export default __webpack_public_path__ + "static/gallery-1-dd8c97a1b450c750ddd62889c7d98971.jpg";